// John Eldhose 20180511
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import LanguageSelector from './LanguageSelector';
import Home from './Home';
import Login from './Login';
import LoginRenew from './LoginRenew';
import HomeLayout from './HomeLayout';
import Recover from './Recover';
import SignUp from './SignUp';
import ResendVerify from './ResendVerify';
import Verify from './Verify';
import NotFound from './NotFound';
import Report from './Report'
import LMDPrint from './LMDPrint';
import TeaserContact from './TeaserContact';
import TeaserDemo from './TeaserDemo';
import TeaserForum from './TeaserForum';
import TeaserReconfig from './TeaserReconfig';
import TeaserRenew from './TeaserRenew';
import TeaserPurchase from './TeaserPurchase';
import './Layout.css';

class Layout extends Component {

  state = {
    reloadHome: false
  }
  reloadHome = () => {
    window.location = 'https://www.carlsonsw.com';
  }

  render() {
    if(window.location.pathname === '/report')
      return <Report />;
    else if(window.location.pathname === '/lmdprint')
      return <LMDPrint />;
    else
      return (
        <Grid container align='center' className="App">
          <Grid item xs={12} sm={12} md={11} lg={11} xl={11} className='AppBody'>
            <Grid container>
              <Grid item xs={12} sm={10} md={9} align='left'>
                <Button onClick={this.reloadHome}>
                  <img
                    src='carlson-logo.png'
                    style={{ width: '200px', height: '54px' }}
                    alt='Carlson Logo'
                  />
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <p />
                <LanguageSelector />
              </Grid>
            </Grid>
            <p />
            <Paper elevation={0} style={{ padding: '15px' }}>
              <div style={{ minHeight: '370px' }}>
                <BrowserRouter basename={'/'}>
                  <Switch>
                    <Route exact path='/' component={Home} />
                    <Route exact path='/home' component={Home} />
                    <Route exact path='/academy' component={HomeLayout} />
                    <Route exact path='/accountdetailsteam' component={HomeLayout} />
                    <Route exact path='/communications' component={HomeLayout} />
                    <Route exact path='/contact' component={HomeLayout} />
                    <Route exact path='/contactsales' component={TeaserContact} />
                    <Route exact path='/demo' component={HomeLayout} />
                    <Route exact path='/downloads' component={HomeLayout} />
                    <Route exact path='/demoproducts' component={TeaserDemo} />
                    <Route exact path='/forumauth' component={TeaserForum} />
                    <Route exact path='/forum' component={HomeLayout} />
                    <Route exact path='/lmdrmas' component={HomeLayout} />
                    <Route exact path='/lmdrmaform' component={HomeLayout} />
                    <Route exact path='/login' component={Login} />
                    <Route exact path='/loginrenew' component={LoginRenew} />
                    <Route exact path='/manageaccount' component={HomeLayout} />
                    <Route exact path='/photocapture' component={HomeLayout} />
                    <Route exact path='/productsplans' component={HomeLayout} />
                    <Route exact path='/profile' component={HomeLayout} />
                    <Route exact path='/purchase' component={HomeLayout} />
                    <Route exact path='/purchaseproducts' component={TeaserPurchase} />
                    <Route exact path='/recover' component={Recover} />
                    <Route exact path='/reconfig' component={HomeLayout} />
                    <Route exact path='/reconfigproduct' component={TeaserReconfig} />
                    <Route exact path='/renew' component={HomeLayout} />
                    <Route exact path='/renewproduct' component={TeaserRenew} />
                    <Route exact path='/resendverify' component={ResendVerify} />
                    <Route exact path='/rmaform' component={HomeLayout} />
                    <Route exact path='/rmas' component={HomeLayout} />
                    <Route exact path='/signup' component={SignUp} />
                    <Route exact path='/shoppingcart' component={HomeLayout} />
                    <Route exact path='/verify' component={Verify} />
                    <Route component={NotFound} />
                  </Switch>
                </BrowserRouter>
              </div>
            </Paper>
            <p />
            <Typography variant="body2">
              <font color='#FFF'>
                <FormattedMessage
                  id='Questions/feedback? Please email'
                  defaultMessage='Questions/feedback? Please email'
                />
                &nbsp;account_help@carlsonsw.com
              </font>
            </Typography>
            <Typography variant="body2">
              <img src="youtube.png" alt="Getting started" height="12" />&nbsp;
              <a href="https://www.youtube.com/watch?v=n62oPCMIjq0">
                 <FormattedMessage
                   id='Getting started with the Carlson Customer Portal'
                   defaultMessage='Getting started with the Carlson Customer Portal'
                 />
              </a>
            </Typography>
          </Grid>
        </Grid>
      );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js